



















import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import ShareDocumentLink from "@/components/modules/document/ShareDocumentLink.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import storeHelper from "@/store/store-helper";

export default Vue.extend({
    name: "LinkDocumentAction",
    components: { DocumentToolbarAction, ZenyaDialog, ShareDocumentLink },
    props: {
        documentProperties: Object as () => DocumentVersionInfo
    },
    data: function () {
        return {
            showShareDialog: false
        };
    },
    watch: {
        showShareDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showShareDialog);
        }
    },
    methods: {
        setShowShareDialog(): void {
            this.showShareDialog = true;
        }
    }
});
